import { useCallback, useState } from "react";

/**
 * Hook: remember which group headers are collapsed on a per-page basis.
 * Persists the Set of collapsed keys to localStorage so a refresh keeps the
 * user's chosen view.  Used by Program Bookings, Weekend Bookings, Arrivals
 * (city + date), and Partner My Applications.
 */
export function useCollapsibleGroups(pageKey) {
  const storeKey = `aii-collapsed-groups:${pageKey}`;
  const [collapsed, setCollapsed] = useState(() => {
    try {
      const raw = localStorage.getItem(storeKey);
      return raw ? new Set(JSON.parse(raw)) : new Set();
    } catch { return new Set(); }
  });
  const persist = useCallback((next) => {
    try { localStorage.setItem(storeKey, JSON.stringify([...next])); } catch { /* localStorage full or blocked */ }
    setCollapsed(next);
  }, [storeKey]);
  const toggle = useCallback((key) => {
    const next = new Set(collapsed);
    if (next.has(key)) next.delete(key); else next.add(key);
    persist(next);
  }, [collapsed, persist]);
  return { collapsed, toggle };
}
